/* eslint-disable */
export default {
  Keyword: 'Keyword',
  Ad: 'AdTitle',
  AdGroup: 'AdgroupName',
  Campaign: 'CampaignName'
};

